import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  text: string;
}

/**
 * ドットアニメーション付きローディングスピナーコンポーネント
 * 複数の画面で共通して使用されるローディング表示
 */
export const LoadingSpinner = ({ text }: LoadingSpinnerProps) => {
  return (
    <div className="loading-spinner">
      <div className="loading-spinner__dots">
        <span className="loading-spinner__dot"></span>
        <span className="loading-spinner__dot"></span>
        <span className="loading-spinner__dot"></span>
      </div>
      <p className="loading-spinner__text">{text}</p>
    </div>
  );
};

